type GrecaptchaApi = {
    render: (container: HTMLElement | string, parameters?: Record<string, unknown>, inherit?: boolean) => number;
    getResponse: (widgetId?: number) => string;
    reset: (widgetId?: number) => void;
};

declare global {
    interface Window {
        grecaptcha?: GrecaptchaApi;
        initializeReCaptcha?: (locale?: string) => void;
        __naisRecaptchaLoading?: boolean;
        __naisRecaptchaOnLoad?: (() => void) | null;
        __naisRecaptchaNetteExt?: boolean;
    }
}

function renderAll(): void {
    const grecaptcha = window.grecaptcha;
    if (!grecaptcha || typeof grecaptcha.render !== 'function') {
        return;
    }

    window.jQuery('.g-recaptcha').each(function renderRecaptchaWidget() {
        const el = window.jQuery(this);
        if (el.children().length) {
            return;
        }
        grecaptcha.render(this as HTMLElement, {}, true);
    });
}

function ensureNetteExtension(): void {
    const $ = window.jQuery;
    if (!$?.nette || window.__naisRecaptchaNetteExt) {
        return;
    }
    window.__naisRecaptchaNetteExt = true;
    $.nette.ext('recaptcha', {
        load() {
            renderAll();
        },
    });
}

/**
 * Load Google reCAPTCHA API (once) and render all `.g-recaptcha` widgets.
 * Safe to call repeatedly after AJAX snippet redraws.
 */
export function initializeReCaptcha(locale?: string): void {
    const $ = window.jQuery;
    if (!$ || typeof $.nette === 'undefined') {
        console.error('nette.ajax.js library is required, please load it.');
        return;
    }

    if (typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.render === 'function') {
        renderAll();
        ensureNetteExtension();
        return;
    }

    if (window.__naisRecaptchaLoading) {
        window.__naisRecaptchaOnLoad = renderAll;
        return;
    }
    window.__naisRecaptchaLoading = true;

    const callbackName = `g_onRecaptchaLoad_${Date.now()}`;
    // Google api.js calls a global onload function by name.
    (window as unknown as Record<string, () => void>)[callbackName] = () => {
        renderAll();
        if (typeof window.__naisRecaptchaOnLoad === 'function') {
            window.__naisRecaptchaOnLoad();
            window.__naisRecaptchaOnLoad = null;
        }
        ensureNetteExtension();
    };

    const hl = locale || $('html').attr('lang') || 'en';
    $('<script />', {
        src:
            'https://www.google.com/recaptcha/api.js'
            + `?onload=${callbackName}`
            + '&render=explicit'
            + `&hl=${encodeURIComponent(hl)}`,
    }).appendTo('head');
}

window.initializeReCaptcha = initializeReCaptcha;
